import DataTable from "react-data-table-component"
import { SyncLoader } from "react-spinners"
import NoDataPrompt from "../../Components/NoDataPrompt/NoDataPrompt"
import "../../Components/TableTemplate/OneTable.css"

export default function PaymentTable({
  tableHeaders,
  headerSelector,
  tableData,
  ActionBtn,
  ViewBtn,
  PendingBtn,
  showLoader,
  withActionData,
}) {
  const columns = tableHeaders.map((header, index) => {
    if (header === "PAYMENT DATE") {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        button: true,
        width: "8rem",
      }
    } else if (header.includes("TYPE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("PMT DATE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("INV NO.")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("COMMISSION")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("PAID AMT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("DEPOSIT DATE")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("DEPOSITED TO")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("REMARKS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("DETAILS")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("PAYMENT AMOUNT")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (header.includes("AMOUNT APPLIED TO INV")) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "8rem",
        left: true,
        wrap: true,
        reorder: true,
      }
    } else if (
      header.includes("PAID AMOUNT") ||
      header.includes("TAX") ||
      header.includes("FEE") ||
      header.includes("TOTAL")
    ) {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        right: true,
        sortable: true,
        width: "8rem",
        reorder: true,
        wrap: true,
      }
    } else {
      return {
        name: header,
        selector: (row) => row[headerSelector[index]],
        // sortable: true,
        width: "auto",
        wrap: true,
        reorder: true,
      }
    }
  })

  const paginationComponentOptions = {
    rowsPerPageText: "",
    noRowsPerPage: true,
  }

  const customStyles = {
    rows: {
      style: {
        minHeight: "5.2vh",
        flexWrap: "wrap",
        fontSize: "12px",
        whiteSpace: "pre",
      },
    },
    headCells: {
      style: {
        flexWrap: "wrap",
        fontSize: "12px",
        width: "100%",
        wordWrap: "breakWord",
      },
    },
  }

  return showLoader ? (
    <div className="d-flex justify-content-center my-5">
      <SyncLoader color="var(--primary-color)" size={15} />
    </div>
  ) : (
    <DataTable
      pagination
      striped
      fixedHeader
      fixedHeaderScrollHeight="50vh"
      columns={columns}
      data={tableData}
      customStyles={customStyles}
      paginationComponentOptions={paginationComponentOptions}
      noDataComponent={<NoDataPrompt />}
    />
  )
}
